module.exports = __webpack_public_path__ + "static/img/meet-the-team_4.4fd0639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/meet-the-team_4.png
// module id = cZrx
// module chunks = 0